<template>
  <div class="flex flex-col min-h-screen">
    <!-- Top Navigation -->
    <div class="flex flex-row w-full">
      <NavigationHeader />
    </div>
    <!-- Sidebar + Main Content -->
    <div class="flex flex-row flex-1">
      <LeftSidebar v-if="isAuthenticated != 'Undefined' && !isLoginPage && !isAdminUser" />
      <main class="flex flex-col flex-1 pb-10">
        <router-view class="pl-0"></router-view>
      </main>
    </div>
    <!-- Footer spans full width, outside the sidebar row -->
    <NavigationFooter />
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import NavigationHeader from './NavigationHeader.vue';
import NavigationFooter from './NavigationFooter.vue';
import LeftSidebar from './LeftSidebar.vue';
import store from '@/store/store';

export default defineComponent({
  components: {
    NavigationHeader,
    NavigationFooter,
    LeftSidebar,
  },
  setup(props, { root }) {
    const isAuthenticated = computed(() => store.getters.fullName);
    const isLoginPage = computed(() => {
      return root.$route.name === 'LogIn';
    });
    const isAdminUser = computed(() => {
      let userRoles = store.getters.roles || [];

      if (typeof userRoles === 'string') {
        // Try to parse as JSON if it's a string
        try {
          const parsed = JSON.parse(userRoles);
          userRoles = Array.isArray(parsed) ? parsed : [userRoles];
        } catch (e) {
          // Not JSON, treat as comma-separated string
          userRoles = userRoles.split(',').map(role => role.trim());
        }
      }

      // Check if any of the user roles is admin-manager or admin_manager
      return Array.isArray(userRoles)
        ? userRoles.some(role => role === 'admin-manager' || role === 'admin_manager')
        : false;
    });

    return {
      isAuthenticated,
      isLoginPage,
      isAdminUser,
    };
  },
});
</script>

<style>
/* ...existing styles... */

/* Add style to completely hide the admin navigation drawer */
.v-navigation-drawer--mini-variant.v-navigation-drawer--width-0 {
  width: 0 !important;
}
</style>
